import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.1504 40.9253C73.1504 40.9253 59.5904 34.0353 55.5404 29.3053C51.0404 24.0453 51.2404 1.40527 51.2404 1.40527H38.8104C38.8104 1.40527 39.1204 24.1553 34.5104 29.3053C29.6204 34.7653 16.9004 40.7252 16.9004 40.7252C23.0904 55.3052 35.4904 59.0253 45.0204 59.0253C54.5604 59.0253 66.9604 55.5153 73.1504 40.9253Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.6805 57.8252C85.1205 45.8152 81.4704 42.5752 76.8004 40.2252C74.5004 39.0652 59.9704 31.3452 59.9704 31.3452C59.9704 31.3452 55.0604 38.2853 45.3804 38.2853C35.7004 38.2853 30.0804 31.3452 30.0804 31.3452C30.0804 31.3452 15.6404 39.0152 13.2404 40.2252C8.57045 42.5752 5.01044 46.2052 3.36044 57.8252C1.88044 68.8852 1.44043 71.6453 1.44043 71.6453H88.5904C88.6004 71.6453 87.9805 68.1252 86.6805 57.8252Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M29.4505 35.9852C25.2705 38.2052 16.6705 42.7653 14.8205 43.6853C11.4905 45.3653 8.37054 47.7653 6.83054 58.6453C6.22054 63.1953 5.63054 68.5153 5.33054 70.6553H2.56055C2.56055 70.6553 4.09052 57.9853 5.16052 53.2753C6.23052 48.5653 8.01053 44.2753 12.6705 41.6353C17.3405 38.9953 29.8005 32.6353 29.8005 32.6353L29.4505 35.9852Z"
        fill="white"
      />
      <path
        d="M60.2305 32.6353C60.2305 32.6353 72.7005 38.9953 77.3605 41.6353C82.0305 44.2753 83.8005 48.5753 84.8705 53.2753C85.9405 57.9853 87.4705 70.6553 87.4705 70.6553H84.7005C84.4005 68.5253 83.8005 63.1953 83.2005 58.6453C81.6605 47.7653 78.5405 45.3553 75.2105 43.6853C73.3705 42.7553 64.7705 38.1952 60.5805 35.9852L60.2305 32.6353Z"
        fill="white"
      />
      <path
        d="M30.32 40.1353L13.79 71.2753H75.39L58.9001 40.8053"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M37.1105 70.6553L40.0305 67.5852H49.6505V56.6252H41.4705V60.3153H34.2705V55.1553L40.0305 49.2552H51.0905L56.8505 55.1553V69.0653L55.3005 70.6553H37.1105Z"
        fill="white"
      />
      <path
        d="M29.8502 32.6052C29.8502 32.6052 35.8402 39.2953 45.3302 39.2953C54.8202 39.2953 60.2202 32.6353 60.2202 32.6353L65.4802 35.3853C65.4802 35.3853 59.6602 44.6353 44.8002 44.6353C31.4802 44.6353 24.9102 35.1653 24.9102 35.1653L29.8502 32.6052Z"
        fill="white"
      />
      <path
        d="M24.3105 34.5553C24.3105 34.5553 31.0705 44.6252 44.8105 44.6252C60.0005 44.6252 66.6105 34.1453 66.6105 34.1453"
        stroke={outline}
        fill="none"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M26.8203 33.1453C29.7403 36.5553 35.6503 41.6653 44.8003 41.6653C54.5303 41.6653 60.5103 36.7652 63.5503 33.2352"
        stroke={outline}
        fill="none"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.0258"
          y1="42.5793"
          x2="45.0258"
          y2="8.54657"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
